import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'src/store';
import { thunks as OrganizationThunks } from 'src/thunks/organization';
import $log from 'src/log/log';
import { OrganizationObject } from '../slices/organization';

export const useAllOrganizations = () => {
  const orgState = useSelector((s) => s.organization);
  const [organizations, setOrganizations] = React.useState<OrganizationObject[]>(orgState.listOrganizations);
  const dispatch = useDispatch();
  const fetchOrganizations = useCallback(async () => {
    $log.debug('fetchOrganizations');
    dispatch(OrganizationThunks.listOrganizations());
  }, [dispatch]);

  React.useEffect(() => {
    // $log.debug('useAllOrganizations', orgState, orgState._status.listOrganizations, orgState._status.listOrganizations?.isFetching)
    // $log.debug('isFetching', orgState._status.listOrganizations?.isFetching)
    if (!orgState._status.listOrganizations?.hasFetched && !orgState._status.listOrganizations?.isFetching) {
      fetchOrganizations();
    }
    // setOrganizations(userState.organizations);
  }, [orgState, fetchOrganizations]);
  return {
    organizations: orgState.listOrganizations,
  };
};
